<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { House } from 'lucide-vue-next'
import { lookupCountry } from '@/utils/geo'
import 'flag-icons/css/flag-icons.min.css'

// v3.19.55: 真实旗帜 SVG (flag-icons 库, 4x3) — 取代色块+国家码字母。
// 历史注: v3.17.4 特意不用 emoji 旗帜 (Windows Chrome 不渲染
// regional-indicator, 只显示字母); SVG 无平台差异, 问题不复存在。
// '??' (未知/查询失败) → UN 旗作中性占位; 'LAN' (私网) → 房子图标。

const props = defineProps<{ ip: string }>()

const cc = ref('??')

const visible = computed(() => props.ip.trim() !== '')
const isLAN = computed(() => cc.value === 'LAN')
const isUnknown = computed(() => cc.value === '??')
// '??' 不是合法 ISO 码, 映射到 UN 旗; 其余小写直配 flag-icons 类名
const flagClass = computed(() => `fi fi-${isUnknown.value ? 'un' : cc.value.toLowerCase()}`)

onMounted(async () => {
  cc.value = await lookupCountry(props.ip)
})
</script>

<template>
  <!-- v3.19.56: mr-1.5 让旗帜与相邻文字留出呼吸间距 (旧色块自带留白, 扁平旗没有) -->
  <span
    v-if="visible && !isLAN"
    class="fi mr-1.5 inline-block rounded-[2px] align-middle shadow-sm ring-1 ring-black/10 dark:ring-white/25"
    :class="flagClass"
    :style="{ width: '21px', height: '15px' }"
    :title="isUnknown ? '地理位置未知' : cc"
  />
  <span
    v-else-if="visible && isLAN"
    class="mr-1.5 inline-flex items-center rounded-[3px] bg-slate-200/80 px-1 dark:bg-slate-700/60"
    style="height: 15px"
    title="局域网"
  >
    <House :size="11" class="shrink-0 text-slate-600 dark:text-slate-300" />
  </span>
</template>
